import { Pagination } from "services/search";
import { FleetVehicleTire, FleetVehicleTireRow } from "./types";
import { DataWithPagination } from "services/api/types";
import { createApiCall, paginatedApiCall } from "services/api/createApiCall";
import { transformFleetVehicleTire, transformFleetVehicleTireRow } from "./transformations";
import { transformErrorResponse } from "services/api/transformation";

/*---------------------------------------------------------------------------------------
  TIRE  - SEARCH
-----------------------------------------------------------------------------------------*/
export const getFleetVehicleTiresAPI = async (
  vehicleId: string,
  pagination: Pagination,
  name?: string | null
): Promise<DataWithPagination<FleetVehicleTireRow>> => {
  let path = `/v1/fleet/tires?name=`;

  if (name) path += `${name}`;
  if (vehicleId) path += `&vehicleId=${vehicleId}`;

  return await paginatedApiCall(path, pagination, transformFleetVehicleTireRow);
};



/*---------------------------------------------------------------------------------------
    DELETE
-----------------------------------------------------------------------------------------*/
export const deleteFleetVehicleTireAPI = async (
  id: string,
  t: (key: string) => string
): Promise<FleetVehicleTire> => {
  const response = await createApiCall(
    {
      path: `/v1/fleet/tires/${id}`,
      method: "DELETE",
    },
    {
      getMessage: {
        success: () => t("admin.fleet.vehicle.tire.message.delete"),
        error: (error: any) => `${transformErrorResponse(error)}`,
      },
    }
  )();

  return transformFleetVehicleTire(response.data);
};